module.exports = "/images/ico-blik.svg?8b34d11e5a7d10ff6885c003bd5acb1d";